module.exports = __webpack_public_path__ + "static/media/supportBoxes.510c0c90.svg";